module.exports = __webpack_public_path__ + "img/editor.0a963382.svg";